import React, { useMemo } from 'react';
import { AlarmClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline, spotsTakenPercent } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Urgency block placed right above the price card. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    days,
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const totalHours = days * 24 + hours;
  const units = [{
    value: totalHours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="rounded-3xl border border-red-400/40 bg-red-400/10 px-5 py-7 text-center sm:px-8 [.chalk_&]:border-red-600/40 [.chalk_&]:bg-red-600/10" data-id="element-33" data-mp="15exwpjnelxdp">
      <p className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.16em] text-red-400 [.chalk_&]:text-red-600" data-id="element-34" data-mp="2zrno9uqauuhx">
        <AlarmClockIcon className="h-5 w-5" strokeWidth={2} aria-hidden="true" data-id="element-35" data-mp="1bzvqu3d4i2jo" />
        Launch price — ends soon
      </p>

      {isExpired ? <p className="mt-4 text-xl font-bold uppercase text-slate-50 [.chalk_&]:text-slate-900" data-id="element-36" data-mp="1gxf3wzy349a1">
          The launch price has ended.
        </p> : <>
          <div className="mx-auto mt-5 grid max-w-md grid-cols-3 gap-2.5 sm:gap-3" aria-hidden="true" data-id="element-37" data-mp="172n8o2rz5yif">
            {units.map(unit => <div key={unit.label} className="flex flex-col items-center justify-center rounded-2xl border border-slate-800 bg-slate-950 px-2 py-4 text-center [.chalk_&]:border-slate-200 [.chalk_&]:bg-slate-50" data-id="element-38" data-mp="1ury9tld8lux3">
                <span className="block text-4xl font-extrabold leading-none tracking-tight tabular-nums text-slate-50 sm:text-5xl [.chalk_&]:text-slate-900" data-id="element-39" data-mp="1kzaekv1wnz0h">
                  {pad(unit.value)}
                </span>
                <span className="mt-2 block text-xs font-semibold uppercase tracking-[0.16em] text-slate-400 [.chalk_&]:text-slate-600" data-id="element-40" data-mp="2igqz4yzct4iq">
                  {unit.label}
                </span>
              </div>)}
          </div>
          <p className="sr-only" role="timer" data-id="element-41" data-mp="2ndeiqwbep5la">
            {totalHours} hours, {minutes} minutes and {seconds} seconds left
            until the launch price ends.
          </p>

          <div className="mt-6 border-t border-slate-800 pt-5 [.chalk_&]:border-slate-200" data-id="element-42" data-mp="2ed88rkex2nqv">
            <div className="flex items-baseline justify-between gap-4 text-xs font-semibold uppercase tracking-[0.14em] text-slate-400 [.chalk_&]:text-slate-600" data-id="element-43" data-mp="29dvc67y8u2b3">
              <span data-id="element-44" data-mp="24lu30uwdgrpa">Launch spots</span>
              <span className="text-red-400 [.chalk_&]:text-red-600" data-id="element-45" data-mp="1znslieelh0fx">Only a few left</span>
            </div>
            <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-slate-950 [.chalk_&]:bg-slate-100" role="progressbar" aria-valuenow={spotsTakenPercent} aria-valuemin={0} aria-valuemax={100} aria-label="Launch spots already taken" data-id="element-46" data-mp="1vn0b3htzkpi2">
              <div className="h-full rounded-full bg-red-400 [.chalk_&]:bg-red-600" style={{
            width: `${spotsTakenPercent}%`
          }} data-id="element-47" data-mp="1losw34j9chip" />
            </div>
            <p className="mt-2 text-right text-sm text-slate-400 [.chalk_&]:text-slate-600" data-id="element-48" data-mp="64jvlvra0ory">
              {spotsTakenPercent}% of spots taken
            </p>
          </div>
        </>}
    </div>;
}